import * as React from 'react';

import SideNav from "./SideNav"
import {reportsPaths} from "../models/PivotNavPaths"
 
const OrdersNav: React.SFC = () => {
    return (  
        <SideNav items={reportsPaths}/>
    );
}
 
export default OrdersNav;